import { useEffect, useState } from "react";
import { Box, Grid, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid, GridColumnProps } from "@roc/ui";
import { observer } from "mobx-react";
import { formatCurrency } from "@roc/ui/utils";
import { Layout } from "@roc/feature-app-core";
import { useUploadLeadsStore } from "../hooks";
import { format } from "date-fns";

const useStyles = makeStyles(() => ({
  gridContainer: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    height: "65vh",
    overflow: "hidden",
  },
}));

const COLUMNS: GridColumnProps[] = [
  {
    field: "eventName",
    headerName: "Event",
    minWidth: 200,
    filter: "agTextColumnFilter",
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: "eventPlace",
    headerName: "Event Place",
    minWidth: 150,
    filter: "agTextColumnFilter",
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: "ownerName",
    headerName: "Sales Owner",
    minWidth: 150,
    filter: "agTextColumnFilter",
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: "createdDate",
    headerName: "Event Date",
    minWidth: 200,
    cellRenderer: "dateCellRenderer",
    filter: "agDateColumnFilter",
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
];

export const LeadUploadHistoryGrid = observer(() => {
  const { uploadLeadsStore } = useUploadLeadsStore();
  const { gridStore } = uploadLeadsStore;

  const frameworkComponents = {
    currencyCellRenderer: (params) => (
      <Box textAlign="right">{formatCurrency(params.value, 0)}</Box>
    ),
    dateCellRenderer: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      return format(date, "MMMM dd, yyyy - hh:mmaaa");
    },
  };

  const onFilterChanged = (params) => {
    const filterModel = params.api.getFilterModel();
    gridStore.setFilterModel(filterModel);
  };

  const onSortChanged = (params) => {
    const sortModel = params.api.getSortModel();
    gridStore.setSortModel(sortModel);
  };

  useEffect(() => {
    gridStore.resetAndFetchGridData();
  }, []);

  return (
    <Layout title={"Upload Leads History"}>
      <DataGrid
        columns={COLUMNS}
        rows={gridStore.gridData.data.rows || []}
        frameworkComponents={frameworkComponents}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
        isLoading={gridStore?.isLoading}
        showFilters={gridStore?.showFilters}
        sortModel={gridStore?.sortModel}
        filterModel={gridStore?.filterModel}
        paginationData={gridStore?.gridData.meta}
        setPageNumber={gridStore?.setPageNumber}
      />
    </Layout>
  );
});
